import React from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle } from 'lucide-react';
import { Button } from 'components/ui/button';
import Tooltip from 'components/ui/tooltip';
import { useProductTour } from 'modules/tour';
import { cn } from 'lib/utils';

export interface HelpTourButtonProps {
  className?: string;
  size?: 'xs' | 'sm' | 'icon';
}

export const HelpTourButton: React.FC<HelpTourButtonProps> = ({ className, size = 'icon' }) => {
  const { t } = useTranslation();
  const { startTour, isRunning } = useProductTour();

  return (
    <Tooltip content={t('tour.start_tour', "Tizim bo'yicha sayohat")} side="bottom">
      <Button
        type="button"
        variant="ghost"
        size={size}
        onClick={startTour}
        disabled={isRunning}
        aria-label={t('tour.start_tour', "Tizim bo'yicha sayohat")}
        className={cn(
          'text-muted-foreground hover:text-foreground transition-colors',
          size === 'icon' && 'h-8 w-8',
          className,
        )}
      >
        <HelpCircle className="h-[18px] w-[18px]" />
      </Button>
    </Tooltip>
  );
};

export default HelpTourButton;
